module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "peter-levine.5b4fb450.jpg" + "?" + Date.now();